/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

const FilterBlock = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'FilterBlock',
    categories: [],
    subcategories: [],
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [showOptions, setShowOptions] = useState(false);

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          categories: currentCategories,
          subcategories: currentSubcategories,
        } = component;

        setState(component);
        setCategories(currentCategories);
        setSubcategories(currentSubcategories);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      categories: { ...categories },
      subcategories: { ...subcategories},
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    categories,
    subcategories,
  ]);

  const titleChange = (e) => {
    // text[activeLanguage] = e.target.value
    console.log("titleChange -> e.target.value", e.target.value)
    // setText({ ...text });
  }

  return (
    <div className="flex justify-start flex-col text-black">
      {/* Single Form */}
      <div className="flex items-end py-4">
        <div className="w-full md:w-full md:mb-0">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Title
              </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            id="grid-first-name"
            type="text"
            onChange={titleChange}
            //value={text[activeLanguage]}
          />
        </div>
      </div>
      {/* End */}

    </div>
  );
};

FilterBlock.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
FilterBlock.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default FilterBlock;
